// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldCheckboxGroup_root__2w8Wi","list":"FieldCheckboxGroup_list__3P4FU","twoColumns":"FieldCheckboxGroup_twoColumns__1K8fR","item":"FieldCheckboxGroup_item__3kOVB"};